import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Form } from "antd"
import DF from "DisplayFramework"
import TitlePage from "components/theme_components/Title"
import WizardSteps from "components/theme_components/WizardSteps"
import GeneralProductData from "./GeneralProductData"
import { useNavigate } from "react-router-dom"
import { AuthContext } from "components/Auth/Auth"
import ConfirmModal from "components/theme_components/ThirdParty/ConfirmModal"
import { dateToString } from "utils/utilsSFS"
import { createOffer, type ParOfferTargetConversionResponse } from "services/pricing"
import Notifications from "components/theme_components/Notifications"
import ProductRate from "./ProductRate"
import ProductFees from "./ProductFees"
import ProductConversion from "./ProductConversion"
import ProductTrigger from "./ProductTrigger"
import ProductAmortissement from "./ProductAmortissement"
import ProductSortie from "./ProductSortie"
import ProductRecapContent from "./ProductRecapContent"
import ProductParticipation from "./ProductParticipation"

const ProductCreation = () => {
  // states for the wizard stepper
  const [current, setCurrent] = useState(0) //current step index
  const [isCompleted, setIsCompleted] = useState(false) // flag to indicate if the wizard is completed

  // generalities
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const { isInspect } = useContext(AuthContext)
  const mgid = localStorage.getItem("mgid")
  const [isFeesSelected, setIsFeesSelected] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any>({})
  const [isAmortissementValide, setIsAmortissementValide] = useState(false)

  //modal visibility states
  const [modalVisible, setModalVisible] = useState(false)
  const [modalVisiblesuccess, setModalVisiblesuccess] = useState(false)
  const [isVisible, setVisible] = useState(false)

  //retrieval of the steps content thatare lists which will be fed to the recap step
  const [rateList, setRateList] = useState<any[]>([]);
  const [partList, setPartList] = useState<any[]>([]);

  const [isPartValid, setIsPartValid] = useState(false)
  const [isChangePartnbdaysmax, setIsChangePartnbdaysmax] = useState(false)
  const [isChangedurationmax, setIsChangedurationmax] = useState(false)
  useEffect(() => {
    if (isChangePartnbdaysmax) {
      setPartList([]);
      
      setIsChangePartnbdaysmax(false);
    }
    if (isChangedurationmax) {
      setRateList([]);
      
      setIsChangedurationmax(false);
    }
  }, [isChangePartnbdaysmax,isChangedurationmax]);
  


  const [isRateValid, setIsRateValid] = useState(false)
console.log({isChangePartnbdaysmax})
  const [feesList, setFeesList] = useState<any[]>([])
  const [conversionList, setConversionList] = useState<ParOfferTargetConversionResponse[]>([])
  const [triggersList, setTriggersList] = useState<any[]>([])
  const [amortizationList, setAmortizationList] = useState<any[]>([])
  const [sortieData, setSortieData] = useState<any>({})

  // variable to hold the duration max value from the form
  const durationmax = form.getFieldsValue()?.durationmax
  const franchiseperiod = form.getFieldsValue()?.partnbdaysmax || 0


  //conditional steps based on the offer depreciation type
  const steps =
    form.getFieldValue("offerdepreciation") !== "INFINE"
      ? [
        { stepcomcode: "GeneralProductData", key: "step1" },
        { stepcomcode: "part", key: "step2" },
        { stepcomcode: "rates", key: "step3" },
        { stepcomcode: "fees", key: "step4" },
        { stepcomcode: "amortization", key: "step5" },
        { stepcomcode: "trigger", key: "step6" },
        { stepcomcode: "exit", key: "step7" },
        { stepcomcode: "conversion", key: "step8" },
        { stepcomcode: "Recap", key: "step9" },
      ]
      : [
        { stepcomcode: "GeneralProductData", key: "step1" },
        { stepcomcode: "part", key: "step2" },
        { stepcomcode: "rates", key: "step3" },
        { stepcomcode: "fees", key: "step4" },
        { stepcomcode: "trigger", key: "step6" },
        { stepcomcode: "exit", key: "step7" },
        { stepcomcode: "conversion", key: "step8" },
        { stepcomcode: "Recap", key: "step9" },
      ]

  const addRate = (items: any) => {
    const updatedList = [
      ...rateList,
      {
        nsc: items[0],
        client: items[1],
      },
    ]
    setRateList(updatedList)
    form.setFieldsValue({ prefinlist: updatedList })
  }



  const addPart = (items: any) => {
    const updatedList = [
      ...partList,
      {
        nsc: items[0],
      },
    ]
    setPartList(updatedList)
    // form.setFieldsValue({ prefinlist: updatedList })
  }


const updatePart = useCallback(
    (updatePart : any[]) => {
      setPartList((prevList) => {
        const updatedList = [...prevList]
        const updatedIndex = updatedList.findIndex((p) => p.nsc.key === updatePart[0].key)

        if (updatedIndex === -1) return prevList

        // Get the updated period's data
        const updatedStartDay = Number(updatePart[0].ratestartday)
        const updatedNbDays = Number(updatePart[0].ratenbdaysmax)
        const updatedEndDay = updatedStartDay + updatedNbDays - 1

        // Update the current period
        updatedList[updatedIndex] = {
          nsc: {
            ...updatePart[0],
            ratestartday: updatedStartDay,
            ratenbdaysmax: updatedNbDays,
            rateendday: updatedEndDay,
            ctesorder: updatedIndex + 1,
          },
        }

        if (updatedIndex === 0 && updatedEndDay >= franchiseperiod) {
          const finalPeriods = [updatedList[0]]
          form.setFieldsValue({ prefinlist: finalPeriods })
          return finalPeriods
        }

        if (updatedEndDay >= franchiseperiod) {
          const finalPeriods = updatedList.slice(0, updatedIndex + 1)
          form.setFieldsValue({ prefinlist: finalPeriods })
          return finalPeriods
        }

        const periodsBeforeUpdate = updatedList.slice(0, updatedIndex + 1)
        const periodsAfterUpdate = updatedList.slice(updatedIndex + 1)

        if (periodsAfterUpdate.length > 0) {
          let currentStartDay = updatedEndDay + 1
          const adjustedPeriodsAfter = []

          for (let i = 0; i < periodsAfterUpdate.length; i++) {
            const period = periodsAfterUpdate[i]
            const originalNbDays = Number(period.nsc.ratenbdaysmax)

            const isLastPeriod = i === periodsAfterUpdate.length - 1
            let adjustedNbDays = originalNbDays

            if (isLastPeriod) {
              const maxPossibleEndDay = franchiseperiod
              const maxPossibleNbDays = maxPossibleEndDay - currentStartDay + 1

              if (currentStartDay + originalNbDays - 1 > franchiseperiod) {
                adjustedNbDays = Math.max(1, maxPossibleNbDays) // Ensure at least 1 day
              }
            }

            const adjustedEndDay = currentStartDay + adjustedNbDays - 1

            if (currentStartDay > franchiseperiod) {
              break
            }

            const adjustedPeriod = {
              nsc: {
                ...period.nsc,
                ratestartday: currentStartDay,
                ratenbdaysmax: adjustedNbDays,
                rateendday: adjustedEndDay,
                ctesorder: updatedIndex + i + 2,
              },
            }

            adjustedPeriodsAfter.push(adjustedPeriod)
            currentStartDay = adjustedEndDay + 1

            if (adjustedEndDay >= franchiseperiod) {
              break
            }
          }

          const finalPeriods = [...periodsBeforeUpdate, ...adjustedPeriodsAfter]
          form.setFieldsValue({ prefinlist: finalPeriods })
          return finalPeriods
        }

        form.setFieldsValue({ prefinlist: updatedList })
        return updatedList
      })
    },
    [form, franchiseperiod, setPartList, setRateList], 
  )

  const updateRate = useCallback(
    (updatedPair: [any, any]) => {
      setRateList((prevList) => {
        const updatedList = [...prevList]
        const updatedIndex = updatedList.findIndex((p) => p.nsc.key === updatedPair[0].key)

        if (updatedIndex === -1) return prevList

        // Get the updated period's data
        const updatedStartDay = Number(updatedPair[0].ratestartday)
        const updatedNbDays = Number(updatedPair[0].ratenbdaysmax)
        const updatedEndDay = updatedStartDay + updatedNbDays - 1

        // Update the current period
        updatedList[updatedIndex] = {
          nsc: {
            ...updatedPair[0],
            ratestartday: updatedStartDay,
            ratenbdaysmax: updatedNbDays,
            rateendday: updatedEndDay,
            ctesorder: updatedIndex + 1, // Ensure correct order
          },
          client: {
            ...updatedPair[1],
            ratestartday: updatedStartDay,
            ratenbdaysmax: updatedNbDays,
            rateendday: updatedEndDay,
            ctesorder: updatedIndex + 1, // Ensure correct order
          },
        }

        if (updatedEndDay >= durationmax) {
          const finalPeriods = updatedList.slice(0, updatedIndex + 1)
          form.setFieldsValue({ prefinlist: finalPeriods })
          return finalPeriods
        }

        const periodsBeforeUpdate = updatedList.slice(0, updatedIndex + 1)
        const periodsAfterUpdate = updatedList.slice(updatedIndex + 1)

        if (periodsAfterUpdate.length > 0) {
          const nextStartDay = updatedEndDay + 1

          let currentStartDay = nextStartDay
          const adjustedPeriodsAfter = periodsAfterUpdate.map((period, idx) => {
            const nbDays = durationmax - currentStartDay + 1
            const endDay = currentStartDay + nbDays - 1

            const adjustedPeriod = {
              nsc: {
                ...period.nsc,
                ratestartday: currentStartDay,
                ratenbdaysmax: nbDays,
                rateendday: endDay,
                ctesorder: updatedIndex + idx + 2,
              },
              client: {
                ...period.client,
                ratestartday: currentStartDay,
                ratenbdaysmax: nbDays,
                rateendday: endDay,
                ctesorder: updatedIndex + idx + 2,
              },
            }

            currentStartDay = endDay + 1

            return adjustedPeriod
          })

          const finalPeriods = [...periodsBeforeUpdate, ...adjustedPeriodsAfter]
          form.setFieldsValue({ prefinlist: finalPeriods })
          return finalPeriods
        }

        form.setFieldsValue({ prefinlist: updatedList })
        return updatedList
      })
    },
    [form, durationmax, setRateList],
  )
  //steps content
  const stepsContent = {
    step1: <GeneralProductData form={form} required={current == 0}  setIsChangePartnbdaysmax={setIsChangePartnbdaysmax} setIsChangedurationmax={setIsChangedurationmax}/>,
    step2: (
      <ProductParticipation
        form={form}
        isInspect={isInspect}
        prefinlist={partList}
        setVisible={setVisible}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        updateRate={updatePart}
        addRate={addPart}
        franchiseperiod={form.getFieldValue("partnbdaysmax") || 0}
        onValidationChange={setIsPartValid}

      />
    ),
    step3: (
      <ProductRate
        form={form}
        isInspect={isInspect}
        prefinlist={rateList}
        setVisible={setVisible}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        updateRate={updateRate}
        addRate={addRate}
        franchiseperiod={form.getFieldValue("partnbdaysmax") || 0}
        onValidationChange={setIsRateValid}
      />
    ),
    step4: (
      <ProductFees
        form={form}
        isInspect={isInspect}
        feesList={feesList}
        setFeesList={setFeesList}
        setVisible={setVisible}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        setSelectedItem={setSelectedItem}
        setIsFeesSelected={setIsFeesSelected}
      />
    ),
    step5: (
      <ProductAmortissement
        form={form}
        required={current === 3}
        amortizationList={amortizationList}
        setAmortizationList={setAmortizationList}
      />
    ),
    step6: (
      <ProductTrigger
        form={form}
        required={false}
        triggersList={triggersList}
        setTriggersList={setTriggersList}
      />
    ),
    step7: <ProductSortie form={form} required={current === 5} sortieData={sortieData} setSortieData={setSortieData} />,
    step8: (
      <ProductConversion form={form} required={current === 6} value={conversionList} onChange={setConversionList} />
    ),
    step9: (
      <ProductRecapContent
        form={form}
        partlist={partList}
        ratelist={rateList}
        feesList={feesList}
        servicesList={form.getFieldValue("amortization")}
        amortizationList={amortizationList}
        triggersList={triggersList}
        sortieData={sortieData}
        conversionList={conversionList}
        isInspect={isInspect}
        isEditable
        isCompleted
        onEditSection={(sectionIndex) => {
          const stepMapping: { [key: number]: number } = {
            0: 0, // General data
            1: 1, // Rates
            2: 2, // Fees
            3: 3, // Amortization
            4: 4, // Trigger
            5: 5, // Exit
            6: 6, // Conversion
          }

          // Navigate to the corresponding step with fallback
          setCurrent(stepMapping[sectionIndex] ?? 0)
        }}
      />
    ),
  }

  // functions to navigate the stepper
  const next = async () => {
    await form
      .validateFields()
      .then((val) => {
        setCurrent((prev) => prev + 1)
      })
      .catch((error) => console.log("Validation failed:", error))
  }

  const prev = () => {
    setCurrent(current - 1)
  }

  const prevIcon = () => {
    current === 0 ? setModalVisible(true) : setCurrent(current - 1)
  }

  const back = () => {
    navigate(`/configuration-sfs?tab=2`)
  }

  const cancel = () => {
    setCurrent(0)
    setModalVisible(true)
  }

  const handleSubmit = async () => {
    const values = form.getFieldsValue()

    let globalKey = 1
    const prefinStepsPart = partList.flatMap(({ nsc, client }, index) => {
      const ctesorder = index + 1

      const validPart = {
        key: globalKey++,
        ...nsc,
        prefinsteptype: "PART",
        nscrateformula: nsc?.nscrateformula || "",
         nscrateformulalabel: nsc?.nscrateformulalabel || "", 
        nscappliedrate: nsc?.nscappliedrate ?? 0,
        ctesorder,
      }

      return [validPart]
    })


    const prefinStepsRate = rateList.flatMap(({ nsc, client }, index) => {
      const ctesorder = index + 1


      const validInt = {
        key: globalKey++,
        ...client,
        prefinsteptype: "INT",
        rateformula: client?.rateformula || "",
        rateformulalabel: client?.rateformulalabel || "", 
        clientappliedrate: client?.clientappliedrate ?? 0,
        ctesorder,
      }

      return [validInt]
    })




    const amortizationSteps = amortizationList.map((step: any, index: number) => ({
      key: globalKey++,
      ctesorder: globalKey++,
      ctesduration: step.ctesduration,
      ctesperiodicityunit: step.ctesperiodicityunit,
      ratestartday: step.amtstartday,
      rateendday: step.amtendday,
      ctesperiodicity: step.cteperiodicity,
      ratenbdaysmax: step.amortbillingday,
      ctesamortizedcoef: step.cteamortizedcoef,
      ctesamortizedamount: step.cteamortizedamount,
      ctesoutstandingcoef: step.ctesoutstandingcoef,
      ctesoutstandingamount: step.ctesoutstandingamount,
      prefinsteptype: "CAP",
      nscbillingcondition: step.amortbillingday < 15 ? "BOP" : "EOP",
    }))

    const parOfferPrefinStepRequest = [...prefinStepsPart, ...prefinStepsRate, ...amortizationSteps]



    const isAuto = values?.isAutomaticConversion

    const offer: any = {
      prcode: values?.prcode,
      offerlabel: values?.offerlabel,
      mgid: mgid,
      startdate: dateToString(values?.startdate),
      durationmax: values?.durationmax,
      taxcode: values?.taxcode,
      partnbdaysmax: values?.partnbdaysmax,
      brandlist: values.brandlist,
      offercode: values.offercode,
      offerdepreciation: values?.offerdepreciation,
      financementType: values?.financementType,
      flaguseassetgrossamount: values.flaguseassetgrossamount,
      feesList: feesList,
      parOfferPrefinStepRequest,
      offertarget: values?.offertarget,
      targetConversions: conversionList,
      isAutomaticConversion: values?.isAutomaticConversion ?? null,
      isCapitalRepayment: isAuto != null ? !isAuto : null,
      offeridtarget: values?.offeridtarget,
      triggersList: triggersList,
    }

    try {
      createOffer({ req: offer }).then((res) => {
        if (res.code === "200") {
          Notifications({
            status: "success",
            message: res.message,
            description: res.description,
            duration: 3,
            placement: "topRight",
          })
          navigate(`/product/recap/${res?.data?.offerid}`)
        } else {
          Notifications({
            status: "error",
            message: res.message,
            description: res.description,
            duration: 3,
            placement: "topRight",
          })
        }
      })
    } catch (error) {
    }
  }

  const isRatePeriodsComplete = useMemo(() => {
    if (current !== 1) return true

    // Calculate total days covered by rate periods
    const totalRateDays = rateList.reduce((sum, item) => {
      return sum + Number(item.nsc?.ratenbdaysmax || 0)
    }, 0)

    // Check if total days equals the maximum duration
    return totalRateDays === Number(form.getFieldValue("durationmax") || 0)
  }, [rateList, form, current])

  return (
    <DF.Provider pagcode="productlist">
      <Form
        layout="vertical"
        form={form}
        labelAlign="left"
        onFinish={(values) => {
        }}
        onFinishFailed={(errorInfo) => {
        }}
        className="productlist"
      >
        <TitlePage
          level={2}
          comcode="NewProduct"
          bgColor="purple"
          noTitleOverlay
          onPrev={!isCompleted ? prevIcon : back}
        />

        <div className="container mt-10" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <WizardSteps
            className="my-custom-class productwizard"
            steps={steps}
            stepsContent={stepsContent}
            // disableNext={(current === 1 && !isRatePeriodsComplete)}
            direction="horizontal"
            currentStep={current}
            onNext={next}
            onPrev={prev}
            nextComcode="Next"
            disableNext={(current === 1 && !isPartValid) || (current === 2 && !isRateValid)}
            prevComcode={current === 0 ? "Réinitialiser" : "Previous"}
            doneComcode="confirme"
            onCancel={cancel}
            onDone={handleSubmit}
            isRecap={!isCompleted}
            classNameProp="container-stepper"
          />
        </div>
      </Form>
      <ConfirmModal
        visible={modalVisible}
        status="error"
        message="Êtes-vous sûr de vouloir annuler ? "
        description="La création de ce produit sera abandonné"
        onConfirm={() => {
          if (isFeesSelected) {

            setFeesList((prev) => prev.filter((p) => p.key !== selectedItem.key))
          } else {
            setRateList((prev) => prev.filter((p) => p.key !== selectedItem.key))
          }

          form.resetFields()
          navigate("/configuration-sfs?tab=2")
          setModalVisible(false)
        }}
        onCancel={() => !isInspect && setModalVisible(false)}
        className="modalConfirmOrCancel"
      />
      <ConfirmModal
        visible={modalVisiblesuccess}
        status="success"
        message="Le produit a été crée avec succès "
        onConfirm={() => {
          setIsCompleted(true)
          setModalVisiblesuccess(false)
        }}
        onCancel={() => !isInspect && setModalVisiblesuccess(false)}
        className="modalConfirmOrCancel"
      />
    </DF.Provider>
  )
}

export default ProductCreation
